// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"combination"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M12 3L16.3302 9.75H7.66992L12 3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 14H10V21H3V14Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5C14 15.567 15.567 14 17.5 14C19.433 14 21 15.567 21 17.5Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M12 3L16.3302 9.75H7.66992L12 3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M3 14H10V21H3V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5C14 15.567 15.567 14 17.5 14C19.433 14 21 15.567 21 17.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-combination')
export default class CombinationIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'combination',
    }
  }
}
